export default "__VITE_ASSET__CoUoY$jC__"